import { call, select, put } from 'redux-saga/effects';
import { teamsModel } from '../../../teams';
import { callApi } from '../../../../shared/api';
import { RT } from '../../../../shared/types';
import { GMAIL_URL } from '../../../../shared/config';

import { marked } from 'marked';
import { markdownToTxt } from '../../lib';

import { callModel } from '../index';
import { createNotification, snackbarModel } from '../../../snackbar';
import { setParams } from '@distribute/shared/utils';

export function* generateFollowUpEmail({
  payload,
}: RT<typeof callModel.actions.generateFollowUpEmail>) {
  try {
    const { participant } = payload;

    yield put(callModel.actions.setIsFollowUpEmailLoading(true));

    const currentCall: RT<
      typeof callModel.selectors.selectCurrentCallWithError
    > = yield select(callModel.selectors.selectCurrentCallWithError);

    const currentSummaryType: RT<
      typeof callModel.selectors.selectCurrentSummaryType
    > = yield select(callModel.selectors.selectCurrentSummaryType);

    const team: RT<typeof teamsModel.selectors.selectCurrentTeamWithError> =
      yield select(teamsModel.selectors.selectCurrentTeamWithError);

    const participants =
      currentCall.calendarAttendees?.map((a) => a.email).join(';') ?? '';

    const emails = participant ? participant : participants;

    const { subject, body }: RT<typeof callApi.generateFollowUpEmail> =
      yield call(
        callApi.generateFollowUpEmail,
        currentCall.id,
        {
          type: currentSummaryType,
          emails,
        },
        { teamId: team.id }
      );

    // If user has not installed the extension, use plain text; otherwise use HTML
    const gmailUrl = `${GMAIL_URL}${setParams({
      view: 'cm',
      su: subject,
      body: markdownToTxt(body),
      bodyHtml: marked(body, { async: false, gfm: true, breaks: true }),
      ...(emails ? { to: emails } : {}),
    })}`;

    window.open(gmailUrl, '_blank');
  } catch (err: unknown) {
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to generate follow-up email')
      )
    );
  } finally {
    yield put(callModel.actions.setIsFollowUpEmailLoading(false));
  }
}
